module.exports = __webpack_public_path__ + "assets/images/icons/close-white.svg?v=e5273560";